import { app } from '../utils/store';
import Lenis from '@studio-freight/lenis';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

class Scroll {
    create = () => {
        app.root.setAttribute('virtualscroll', true);

        app.virtualscroll = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.0001 - Math.pow(2, -10 * t)),
            direction: 'vertical',
            gestureDirection: 'vertical',
            smooth: true,
            mouseMultiplier: 1,
            smoothTouch: false,
            touchMultiplier: 1,
            infinite: false,
        });

        function renderAnimationFrames(time) {
            app.virtualscroll.renderAnimationFrames(time);
            requestAnimationFrame(renderAnimationFrames);
        }

        requestAnimationFrame(renderAnimationFrames);
    };

    scrollBehaviour = (entry) => {
        entry.onclick = (event) => {
            event.preventDefault();
            var target = document.querySelector(event.target.hash);
            var targetRect = target.getBoundingClientRect();
            var offset = window.pageYOffset + targetRect.top - target.clientHeight / 10;
            console.log('Offset:', offset);
            console.log('Duration:', gsap.utils.mapRange(0, app.root.scrollHeight, 0, 2.5, offset));

            gsap.to(window, {
                duration: gsap.utils.mapRange(0, app.root.scrollHeight, 0, 2.5, offset),
                scrollTo: { y: offset, autoKill: true },
                ease: 'Power2.easeInOut',
            });
        };
    };

    scrollToY = (entry) => {
        app.virtualscroll.scrollTo(Number(entry), false);
    };

    destroy = () => {
        app.virtualscroll.destroy();
        app.root.removeAttribute('virtualscroll');
    };
}

export const ScrollManager = new Scroll();
